import React from 'react';
import { BACKEND_URL } from '../constants';
import logo from '../netgen_logo.png';

const DEMO_PAGE_URL =
  process.env.PUBLIC_URL + '/interactive_background/demo/index.html';

export default function Login() {
  const onLogin = () => {
    window.location.href = `${BACKEND_URL}/auth/login`;
  };

  return (
    <div className="intro-container">
      <iframe
        src={DEMO_PAGE_URL}
        title="Interactive Background"
        className="background-iframe"
      />
      <img src={logo} alt="NetGen logo" className="intro-logo intro-title" />
      <div className="login-card animated-options">
        <button
          className="intro-button login-submit"
          type="button"
          onClick={onLogin}
        >
          Log in with Keycloak
        </button>
      </div>
    </div>
  );
}
